import { Spinner } from "reactstrap";

const Loading = ({ className }) => {
  return (
    <div className={className}>
      <Spinner color="#23BBB8" />
    </div>
  );
};
export default Loading;
